<template>
  <v-container>
    <div class="verticle-center" v-if="!success">
      <v-card elevation="0" outlined width="600">
        <v-card-title class="primary--text">
          <b>{{ $t('emailUnsubscribeTitle') }}</b>
        </v-card-title>
        <v-card-subtitle class="primary--text">
          {{ $t('emailUnsubscribeSubtitle') }}
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="primary" :loading="loading" :disabled="loading" @click="onConfirm">
            {{ $t('emailUnsubscribeConfirmButton') }}
          </v-btn>
          <v-spacer/>
        </v-card-actions>
      </v-card>
    </div>
    <v-overlay v-model="success" v-if="success">
      <v-alert type="success" color="primary">
        <div v-html="$t('confirmEmailUnsubscribeMessage')"/>
      </v-alert>
    </v-overlay>
  </v-container>
</template>

<script>
import { apiV1EmailCampaigns } from '../service/resources/api-v1-email-campaigns'
  export default {
    name: 'EmailUnsubscribe',
    data: () => ({
      loading: false,
      success: false
    }),
    methods: {
      onConfirm () {
        this.loading = true
        apiV1EmailCampaigns.unsubscribe(this.$route.params.token).then(() => {
          this.$commons.updateSnackbar({show: true, color: 'success', text: this.$t('success')})
          this.success = true
        }).catch(() => {
          this.loading = false
        })
      }
    },
  }
</script>
<style scoped>
@media (min-width: 1264px) {
  .container {
    max-width: 600px;
  }
}

@media (min-width: 960px) {
  .container {
      max-width: 600px;
  }
}
</style>
